import { Customer, ICustomer } from '@precheckin/models/customer.model';
import { TrainingStatus } from '@precheckin/models/enums/training-status.enum';
import {
  ITrainingClient,
  TrainingClient
} from '@precheckin/models/training/training-client.model';

import { EClientTsaStatus } from './training-client-tsa-status.enum';

export interface ITraining {
  id: string;
  visitId: string;
  client: ITrainingClient;
  customer: ICustomer;
  startDate: string;
  endDate: string;
  geminiReservationIds: string[];
  trainingCenterId: string;
  isPaid: boolean;
  status: TrainingStatus;
  tsaStatus?: EClientTsaStatus;
}

export class Training implements ITraining {
  id: string;
  visitId: string;
  client: TrainingClient;
  customer: Customer;
  startDate: string;
  endDate: string;
  geminiReservationIds: string[];
  trainingCenterId: string;
  isPaid: boolean;
  status: TrainingStatus;
  tsaStatus?: EClientTsaStatus;

  constructor(clone: Training = null) {
    this.id = '';
    this.visitId = '';
    this.client = new TrainingClient();
    this.customer = new Customer();
    this.startDate = '';
    this.endDate = '';
    this.geminiReservationIds = [];
    this.trainingCenterId = '';
    this.isPaid = false;
    this.status = null;
    this.tsaStatus = null;

    if (clone) {
      this.id = clone.id;
      this.visitId = clone.visitId;
      this.client = clone.client;
      this.customer = clone.customer;
      this.startDate = clone.startDate;
      this.endDate = clone.endDate;
      this.geminiReservationIds = clone.geminiReservationIds;
      this.trainingCenterId = clone.trainingCenterId;
      this.isPaid = clone.isPaid;
      this.status = clone.status;
      this.tsaStatus = clone.tsaStatus;
    }
  }
}
